import React from 'react'

type CTAButtonProps = {
  children: React.ReactNode
  onClick?: () => void
}

const CTAButton = ({ children, onClick }:CTAButtonProps) => {
  return (
    <button className='cta-button relative z-0' type='button' onClick={onClick}>
      <div className='cta-button-color-overlay-fx lg:w-72 lg:h-[87px] absolute -left-2 top-3 w-72 h-16 lg:-left-5 lg:top-3 rounded-[50px]' />
      <div className='lg:w-72 lg:h-[87px]' style={{ position: 'relative', zIndex: 2 }}>
        <p className='cta-text flex justify-center items-center w-72 h-16 lg:w-72 lg:h-[87px] gap-2.5 p-2.5 rounded-[50px] border-2 border-[#333] flex-grow-0 flex-shrink-0 text-2xl font-bold text-left text-[#333]'>
          {children}
        </p>
      </div>
    </button>
  )
}

export default CTAButton
